import { useTranslation } from 'react-i18next'
import { OrderData } from '~/shared/api/services/warehouses/types'
import { AssemblyOrderCard } from './order-card'

interface ExpressOrdersSectionProps {
  orders: OrderData[]
  adaptiveFontSize: (text: string) => string
  onOpenOrder: (order: OrderData) => void
}

export const ExpressOrdersSection = ({
  orders,
  adaptiveFontSize,
  onOpenOrder,
}: ExpressOrdersSectionProps) => {
  const { t } = useTranslation(['assembly'])

  if (orders.length === 0) return null

  return (
    <div className="mb-8">
      <p className="mb-4 text-[24px] font-medium">
        {t('assembly:expressDelivery')}
      </p>
      <div className="flex flex-wrap gap-4">
        {orders.map((order) => (
          <AssemblyOrderCard
            key={order.id}
            order={order}
            className="text-center w-[150px] h-[50px]"
            adaptiveFontSize={adaptiveFontSize}
            onOpen={onOpenOrder}
          />
        ))}
      </div>
    </div>
  )
}
